var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AAddItemButtonLink",on:{"click":_vm.click}},[_c('a-add-item-icon',{attrs:{"size":_vm.iconSize}}),_c('p',{class:_vm.textClass},[_vm._v(_vm._s(_vm.$t('dict.addToChannel')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }